import React, { useEffect, useRef, useState } from 'react'
import { Button, Icon } from '@mui/material';
import "./styles.css";
import { IDadosBlog, UtilidadeService } from '../../services/api/utilidades/UtilidadesService';
import { IDadosModal } from '../modal/DialogMensagem';
import ReactPlayerYouTube from 'react-player/youtube'
import Grid from '@mui/material/Grid2';

export type IExportProps = {
    children?: React.ReactNode;
}

export const Carousel: React.FC<IExportProps> = () => {
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [lstCarousel, setLstCarousel] = useState<IDadosBlog[]>([]);
    const [showModalMensagem, setShowModalMensagem] = useState(false);    
    const [elements, setElements] = useState<JSX.Element[] >([]);    
        const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const timeOutRef = useRef<NodeJS.Timeout>();
    const delay: number = 8000;
    const resetTimeOut = () => {
        if (timeOutRef.current) {
            clearTimeout(timeOutRef.current);
        }
    };

    const handleArrowRight = () => {
        if (activeIndex === elements.length - 1) {
            setActiveIndex(0);
        } else setActiveIndex(activeIndex + 1);
    };

    const handleArrowLeft = () => {
        if (activeIndex === 0) {
            setActiveIndex(elements.length - 1)
        } else {
            setActiveIndex(activeIndex - 1);
        }
    };

    function iframe(url: string, tipo: number) {
        return (
            <>
                {tipo === 1 ? (
                    <iframe style={{ borderRadius: "12px", height: UtilidadeService.isMobile() ? "186px" : "235px"  }}
                        src={url}
                        width="100%" 
                        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                        loading="lazy" ></iframe >
                ) :
                    tipo === 2 ?
                        (
                            <ReactPlayerYouTube url={url} width={"100%"} height={235} />)

                        :
                        <img
                            srcSet={url}
                            src={url}
                            alt={`img ${tipo}`}
                            loading="lazy"
                            width="100%" height="235"
                        />


                }
            </>
        )
    }

    useEffect(() => {
        setElements([]);
        const fetchData = async () => {
            await UtilidadeService.getListaUrlBlogs(2)
                .then((result) => {
                    setLstCarousel(result.dado);                    
                    result.dado.map(m => (
                        elements.push(iframe(m.url, m.tipo))
                    ));
                    setElements(elements);                   
                })
                .catch((errors) => {                 
                    setShowModalMensagem(true);                 
                    //console.log(errors);
                    if (errors.response != undefined && errors.response.data.statusHTTP === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });                       
                        return;
                    }
                    if (errors.response !== undefined && errors.response.data.mensagem !== undefined) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }
                    else {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Não foi possível carregar os dados da tela inicial! Favor entrar em contato com a TI ",
                            display: "none",
                            titulo: "Atenção"
                        });                      
                        return;
                    }
                });
            //let atual = "https://open.spotify.com/embed/episode/4vEuSAruNsQayrVePuzqwG?utm_source=generator"

        }
        fetchData();
    }, []);

    useEffect(() => {
        resetTimeOut();
        timeOutRef.current = setTimeout(() => { setActiveIndex((prevIndex: number) => prevIndex === elements.length - 1 ? 0 : prevIndex + 1) }, delay);

        return () => {
            resetTimeOut();
        };
    }, [activeIndex]);
    return (
        <Grid container size={{ xs: 12 }} className={"slideVisible"}>
            <Grid size={{ xs: 12 }} className="slideContainer"
                sx={{ transform: `translate3d(${-activeIndex * 100}%,0,0)` }}>
                { elements.map((colored, index) => (
                    <Grid size={{ xs: 12 }} height={UtilidadeService.isMobile() ? "210px" : "auto"}
                        textAlign={"center"}
                        padding={"8px"}
                        key={index}
                        className="slide"
                    >{colored}</Grid>

                ))}
            </Grid>
            {elements.length > 1 && (<>
                <Grid size={{ xs: 4 }} display={"flex"} justifyContent={"right"}>
                    <Button onClick={handleArrowLeft} className="leftArrow">
                        <Icon>arrow_back_ios_icon</Icon>
                    </Button>
                </Grid>
                <Grid size={{ xs: 4 }} className="slideDotsContainer">
                    {elements.map((_, index) => (
                        <Grid size={{ xs: 1 }}
                            key={index}
                            className={`slideDots ${activeIndex === index ? "active" : ""}`}
                            onClick={() => setActiveIndex(index)}
                        ></Grid>
                    ))}
                </Grid>
                <Grid size={{ xs: 4 }}>
                    <Button onClick={handleArrowRight} className="rightArrow">
                        <Icon>arrow_forward_ios_icon </Icon>
                    </Button>
                </Grid>
            </>)}

        </Grid>
    )
}